import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { Trending } from '@common/models/trending';

@Injectable({ providedIn: 'root' })
export class TrendingService {

  private readonly _baseUrl = `${environment.commonApiUrl}/api/trending`;

  constructor(private _http: HttpClient) {}

  /**
   * Devuelve el Top de tendencias completo (todas las filas de la tabla).
   */
  findAll(): Observable<Trending[]> {
    return this._http.get<Trending[]>(this._baseUrl);
  }

  /**
   * Devuelve las tendencias visibles para un usuario según los menús
   * asociados a sus roles.
   * @param userId Id numérico del usuario
   */
  findByUserId(userId: number): Observable<Trending[]> {
    return this._http.get<Trending[]>(`${this._baseUrl}/user/${userId}`);
  }

  /**
   * Devuelve las tendencias del usuario filtradas por tipo de elemento
   * (ej. type = 'Dashboard' para el listado de dashboards).
   * @param userId Id numérico del usuario
   * @param type Tipo de elemento
   */
  findByUserIdAndType(userId: number, type: string): Observable<Trending[]> {
    return this._http.get<Trending[]>(`${this._baseUrl}/user/${userId}/type/${type}`);
  }
}
